import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { BAPortlet, curLang, eppConfig, EppPortlet, IgixRepo, Portlet, PortletRepo } from '@gspwidget/util';
import { TranslateService } from '@ngx-translate/core';

interface PortletItem<ChildrenT extends Portlet> {
  // title?: string
  portlet?: ChildrenT
  layer?: number
  isPortlet?: boolean
}
interface Menu {
  portletsAmount?: number
  title?: string
  layer: number
}
interface Category<ChildrenT extends Portlet> extends Menu {
  children?: PortletItem<ChildrenT>[]
  isCategory: boolean
}
interface BO<ChildrenT> extends Menu {
  children?: ChildrenT[]
  code?: string
  id?: string
  name?: string
  parentID?: string
}

@Component({
  selector: 'pl-draggable-portlet-list',
  templateUrl: './draggable-portlet-list.component.html',
  styleUrls: ['./draggable-portlet-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DraggablePortletListComponent implements OnInit {

  tree: (BO<BO<PortletItem<EppPortlet | BAPortlet>>> | Category<EppPortlet | BAPortlet>)[]
  eppPortletItems: PortletItem<EppPortlet>[]
  @Output() dragPortlet = new EventEmitter<Portlet>()
  searchPortletList: EppPortlet[]
  @Input() portalCustomizePortlets: [];
  @Input() isUserDesigner: boolean;
  userCustomizePortlets: EppPortlet[]

  constructor (
    public translate: TranslateService,
    private portletRepo: PortletRepo,
    private igixRepo: IgixRepo,
    public cd: ChangeDetectorRef,
  ) { }

  ngOnInit () {
    // 用户定制的部件
    if(this.isUserDesigner && this.portalCustomizePortlets){
      this.portletRepo.getPortlets().subscribe(res => {
        this.userCustomizePortlets = res.filter(item => this.portalCustomizePortlets.some(c=> c===item.id))
        this.cd.markForCheck();
      })
    } else {
      // 获取 portlets 列表塞入 bo tree
      this.portletRepo.getPortletsByModuleId().subscribe(portlets => {
        this.eppPortletItems = portlets.map(p => ({
          portlet: p,
          isPortlet: true,
          title: p.name,
        }))
        this.igixRepo.getPortletCategoryTree().subscribe((boTree: BO<BO<any>>[]) => {
          const sysPortletMenus = this.eppPortletItems.filter(p => !p.portlet.moduleId)
          sysPortletMenus.forEach(p => p.layer = 1)
          const commonPortlets: Category<EppPortlet> = {
            title: 'commonPortlets',
            isCategory: true,
            layer: 1,
            children: sysPortletMenus.filter(pm => !Portlet.IsDemoPortlet(pm.portlet))
          }
          const demoPortlets: Category<EppPortlet> = {
            title: 'demoPortlets',
            isCategory: true,
            layer: 1,
            children: sysPortletMenus.filter(pm => Portlet.IsDemoPortlet(pm.portlet))
          }
          this.tree = [commonPortlets, ...boTree, demoPortlets]
          if (eppConfig && eppConfig.enableBAInHome) this.initBAMenu()
          this.cd.markForCheck()
        })
      })
    }
  }

  initBAMenu () {

    this.igixRepo.getBAPortletsAll().subscribe((baPortlets: BAPortlet[]) => {
      const baPortletMenus: PortletItem<BAPortlet>[] = baPortlets.map(p => ({
        portlet: p,
        isPortlet: true,
        layer: 1
      }))
      // 如果有 BA 部件
      const baPortletCategory: Category<BAPortlet> = {
        title: 'BAPortlet',
        isCategory: true,
        layer: 0,
        children: baPortletMenus,
        portletsAmount: baPortlets.length
      }
      this.tree.push(baPortletCategory)
      this.tree = this.tree.slice()
      this.cd.markForCheck()
    })
  }
  
  handleWidgetDragStart (portlet: EppPortlet | BAPortlet, dragE: DragEvent) {
    portlet['preview'] = false
    dragE.dataTransfer.setData('text', JSON.stringify({ p: portlet }))
    // dragE.dataTransfer.setData('text/plain', JSON.stringify(portlet))
    // this.gridDesigner.onDragPortlet(portlet)
    // payload.dragE.dataTransfer.dropEffect = 'copy';
    this.dragPortlet.emit(portlet)
  }
  handleSubmenuOpenChange (opened: boolean, menu) {
    if (opened && !menu.children) {
      this.portletRepo.getPortletsByModuleId(menu.id).subscribe(ps => {
        if (ps.length === 0) {
          menu.isEmpty = true
        }
        menu.children = ps.map(p => ({
          portlet: p,
          isPortlet: true,
          layer: parseInt(menu.layer) + 1
        }))
        this.cd.markForCheck()
      })
    }
  }

  searchPortlet(value: string){
    if(value){
      this.portletRepo.getPortletsByName(value).subscribe(res => {
        if(this.isUserDesigner && this.portalCustomizePortlets){
          this.searchPortletList = res.filter(item => this.portalCustomizePortlets.some(c=> c === item.id))
        } else {
          this.searchPortletList = res;
        }
        this.cd.markForCheck();
      })
    } else {
      this.searchPortletList = null;
    }
  }
  mousedown(portletItem){
    portletItem.preview = false;
    this.cd.markForCheck();
  }
  mouseup(portletItem){
    portletItem.preview = null;
    this.cd.markForCheck();
  }
}
